import { css } from "styled-components";

export const muiOverridesStyles = css`
  div.MuiFormControl-root:has(input:autofill)
    label.MuiInputLabel-root.MuiInputLabel-formControl[data-shrink="false"] {
    display: none !important;
  }
  div.MuiFormControl-root:has(input:-webkit-autofill)
    label.MuiInputLabel-root.MuiInputLabel-formControl[data-shrink="false"] {
    display: none !important;
  }

  .MuiFormControl-root {
    input:-webkit-autofill,
    input:-webkit-autofill:focus {
      transition:
        background-color 0s 600000s,
        color 0s 600000s !important;
    }
  }

  .MuiFormControlLabel-root {
    cursor: unset;
  }
`;
